import IconsEnum from "../../classes/enums/IconsEnum";
import { iconMapping } from "../../config/iconConfig";
import { useKeyboardActivation } from "../../hooks/useKeyboardActivation";
import "./ImportArea.css";

const ImportArea = ({ comment, modality, onClick }) => {
  const IconComponent = iconMapping[IconsEnum.UPLOAD];

  return (
    <div
      key={modality}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={useKeyboardActivation(onClick)}
      className="import-area"
    >
      <IconComponent />
      <div className="import-area-comment App-text-small">{comment}</div>
    </div>
  );
};
export default ImportArea;
